module.exports = __webpack_public_path__ + "img/00006.acd7d440.webp";